import React from "react";
import PropTypes from "prop-types";
import HoverTooltip from "../../../components/atoms/Tooltip/HoverTooltip";
import renderDiseases from "../helpers/renderDiseases";
import styles from "../custom-styles/_custom-link.module.scss";
import GeneWithRefGenomeLink from "../../../common/helpers/GeneWithRefGenomeLink";

const SingleLineCnvResults = ({ values, hostUrl, pathogenicGenes }) => {
  if (!values) return null;

  return (
    <>
      {values.map((value, index) => {
        return (
          <React.Fragment key={`${value}-coding-mutlti-expander-${index}`}>
            <HoverTooltip
              disabled={!renderDiseases(value, pathogenicGenes)}
              ContentRenderer={() => {
                const result = renderDiseases(value, pathogenicGenes);
                return result?.disease ? (
                  <div key={`${result.gene}-disease-unique`}>
                    <h4 className="tw-ml-6">Associated diseases</h4>
                    <ul className="tw-mt-2 tw-list-disc">
                      {result.disease.map((info, infoIdx) => (
                        <li key={`${info}-${infoIdx}-disease-info`}>{info}</li>
                      ))}
                    </ul>
                  </div>
                ) : null;
              }}
            >
              <span>
                {index > 0 && ", "}
                <span
                  className={
                    pathogenicGenes &&
                    pathogenicGenes.some(
                      (pathoValue) => pathoValue.gene === value
                    )
                      ? `${styles.customPathogenicLink} tw-mt-1 tw-text-sm`
                      : "tw-mt-1 tw-text-sm"
                  }
                >
                  <GeneWithRefGenomeLink
                    target="_blank"
                    href={`${hostUrl}/gene/${value}`}
                    rel="noreferrer"
                  >
                    {value}
                  </GeneWithRefGenomeLink>
                </span>
              </span>
            </HoverTooltip>
          </React.Fragment>
        );
      })}
    </>
  );
};

SingleLineCnvResults.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  hostUrl: PropTypes.string,
  pathogenicGenes: PropTypes.arrayOf(
    PropTypes.shape({
      disease: PropTypes.arrayOf(PropTypes.string),
      gene: PropTypes.string,
    })
  ),
};

SingleLineCnvResults.defaultProps = {
  values: [],
  hostUrl: "",
  pathogenicGenes: null,
};

export default SingleLineCnvResults;
